import { useState, Suspense } from 'react'
import { useLoaderData, useRouteLoaderData } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { CreditCardForm } from '@/components/subscription/checkout/credit-card-form'
import { Button } from '~/components/subscription/button'
import { TextLink } from '@/components/subscription/text-link'
import { formatTime } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { Subscription, Card } from '@/api-client/data-contracts'
import { styles } from './styles.css'

export const loader = async () => {
  return await fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

const creditCardPromise = Promise.resolve(null)

export const SubscriptionMypageCard: React.FC = () => {
  const {
    data: { data: account },
  } = useRouteLoaderData('mypageLayout')
  const {
    data: { data: subscriptions },
  } = useLoaderData()

  const subscription = subscriptions[0] as unknown as Subscription
  const [creditCard, setCreditCard] = useState<Card | null>(null)
  const [holderName, setHolderName] = useState('')
  const [numberElement, setNumberElement] = useState(null)
  const [email, setEmail] = useState(account ? account.attributes.email : '')

  const handleUpdateCard = ({ holderName, numberElement }) => {
    setHolderName(holderName)
    setNumberElement(numberElement)
  }

  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      const res = await window.payjpInstance.createToken(numberElement, {
        three_d_secure: true,
        card: { email, name: holderName },
      })

      if ('id' in res) {
        const formData = new FormData()
        formData.append('card_token', res.id)

        const response = await window.fetch(`/cards?next=${encodeURIComponent('/subscription/mypage')}`, {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content,
          },
        })
        const { tds_url } = await response.json()

        location.href = tds_url
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Flex direction="column" align="center" gap="40px" width="100%">
      <PageHeading>クレジットカード変更</PageHeading>
      {subscription && (
        <p className={styles.warn}>
          {formatTime(1000 * subscription.attributes.skip_deadline)}までに変更すると、
          <br />
          次回分の注文に反映されます
        </p>
      )}
      <Suspense fallback={<></>}>
        <CreditCardForm creditCard={creditCardPromise} onInitialized={setCreditCard} onUpdate={handleUpdateCard} />
      </Suspense>
      <Flex direction="column" align="center" gap="32px" width="100%">
        <Button as="button" size="m" fluid onClick={handleSubmit}>
          クレジットカードを変更する
        </Button>
        <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
      </Flex>
    </Flex>
  )
}
